import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { FsMessage, MessageMode } from '@firestitch/message';

import { AclService } from '@app/core/services';

@Injectable()
export class AdminGuard  {
  private _aclQueryService = inject(AclService);
  private _router = inject(Router);
  private _message = inject(FsMessage);


  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): true | UrlTree {
    if (this._aclQueryService.hasPermissionAdmin() || this._aclQueryService.hasPermissionSystem()) {
      return true;
    }

    this._message
      .error('Sorry, but you haven\'t permission for this page', { mode: MessageMode.Toast });

    return this._router.createUrlTree(['/']);
  }

}
